module.exports = __webpack_public_path__ + "img/ARIA-ico.e3825d2e.svg";